export default function hidePersonalIdentityNumber(input) {
  input.type = 'hidden';
  input.readOnly = true;
  const placeholder = document.getElementById( input.id + '_placeholder' );
  let maskedValue;
  if (input.value && input.value.length > 4) {
    maskedValue = input.value.slice(0, -4) + '****';
  }
  placeholder.value = maskedValue || '';
  placeholder.type = 'text';
  placeholder.disabled = true;
}